(function () {
  if (window.__productAnchorNavInit) return;
  window.__productAnchorNavInit = true;
  window.__productAnchorNavPageLoaded = document.readyState === 'complete';

  var DEFAULT_STICKY_TOP = 64;
  var SECTION_SELECTOR = '[data-product-anchor-nav-section]';
  var HOLDER_SELECTOR = '[data-product-anchor-nav-holder]';
  var LIST_SELECTOR = '[data-product-anchor-nav-list]';
  var TARGET_SELECTOR = '[data-anchor-nav-title]';
  var SCROLL_ALIGN_TOLERANCE = 4;
  function toArray(nodes) {
    return Array.prototype.slice.call(nodes || []);
  }

  function debounce(callback, wait) {
    var timer = null;

    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(null, args);
      }, wait);
    };
  }

  function rafThrottle(callback) {
    var ticking = false;

    return function () {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(function () {
        ticking = false;
        callback();
      });
    };
  }

  var MOBILE_BREAKPOINT = 767;

  function getHeaderOffset() {
    var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    var cssVar = isMobile ? '--s-header-m-height' : '--header-height';
    var rootValue = window.getComputedStyle(document.documentElement).getPropertyValue(cssVar);
    var parsedValue = parseFloat(rootValue);

    if (Number.isFinite(parsedValue) && parsedValue > 0) {
      return parsedValue;
    }

    if (isMobile) {
      var mobileHeader = document.querySelector('#home-s-header-mobile, [id*="header-mobile"]');
      if (mobileHeader && mobileHeader.offsetHeight > 0) {
        return mobileHeader.offsetHeight;
      }
    } else {
      var header = document.querySelector('#home-s-header');
      if (header && header.offsetHeight > 0) {
        return header.offsetHeight;
      }
    }

    return DEFAULT_STICKY_TOP;
  }

  function normalizeTarget(item, index) {
    var element = item.element;
    var title = (item.title || '').trim();
    var hash = (item.hash || '').trim();

    if (!element || !title) return null;
    if (!element.getBoundingClientRect) return null;

    if (!hash) {
      hash = element.id || 'anchor-nav-' + (index + 1);
    }

    if (!element.id) {
      element.id = hash;
    }

    return {
      element: element,
      title: title,
      hash: hash,
      domIndex: item.domIndex,
      top: 0
    };
  }

  function collectTargets(sectionElement) {
    var domIndex = 0;
    var items = toArray(document.querySelectorAll(TARGET_SELECTOR))
      .filter(function (element) {
        return !sectionElement.contains(element);
      })
      .map(function (element) {
        domIndex += 1;
        return normalizeTarget(
          {
            element: element,
            title: element.getAttribute('data-anchor-nav-title'),
            hash: element.getAttribute('data-anchor-nav-id') || element.id,
            domIndex: domIndex
          },
          domIndex
        );
      })
      .filter(Boolean);

    items.sort(function (first, second) {
      return first.domIndex - second.domIndex;
    });

    var usedHashes = {};

    return items.filter(function (item) {
      if (usedHashes[item.hash]) return false;
      usedHashes[item.hash] = true;
      return true;
    });
  }

  function getTotalOffset(sectionElement) {
    var navElement = sectionElement.querySelector(HOLDER_SELECTOR);
    var headerOffset = getHeaderOffset();
    var navHeight = navElement ? navElement.offsetHeight : 0;
    return headerOffset + navHeight + 16;
  }

  function getAbsoluteTop(element) {
    return window.pageYOffset + element.getBoundingClientRect().top;
  }

  function updateOffsets(sectionElement, items) {
    var headerOffset = getHeaderOffset();
    var totalOffset = getTotalOffset(sectionElement);
    var holderElement = sectionElement.querySelector(HOLDER_SELECTOR);

    sectionElement.style.setProperty('--product-anchor-nav-header-offset', headerOffset + 'px');
    sectionElement.style.setProperty('--product-anchor-nav-total-offset', totalOffset + 'px');
    sectionElement.style.minHeight = (holderElement ? holderElement.offsetHeight : 0) + 'px';
    sectionElement.__stickyStartTop = getAbsoluteTop(sectionElement);

    items.forEach(function (item) {
      item.element.style.setProperty('--product-anchor-nav-total-offset', totalOffset + 'px');
    });
  }

  function refreshMeasurements(sectionElement, items) {
    updateOffsets(sectionElement, items);

    items.forEach(function (item) {
      item.top = getAbsoluteTop(item.element);
    });
  }

  function setStickyState(sectionElement) {
    if (!window.__productAnchorNavPageLoaded) {
      sectionElement.classList.remove('is-sticky');
      return;
    }

    var stickyStartTop = sectionElement.__stickyStartTop;

    if (!Number.isFinite(stickyStartTop)) {
      stickyStartTop = getAbsoluteTop(sectionElement);
    }

    sectionElement.classList.toggle('is-sticky', window.pageYOffset + getHeaderOffset() >= stickyStartTop);
  }

  function setActiveLink(sectionElement, activeHash) {
    if (sectionElement.__activeHash === activeHash) return;

    var links = toArray(sectionElement.querySelectorAll('.productAnchorNav__link'));

    links.forEach(function (link) {
      var isActive = link.getAttribute('data-anchor-hash') === activeHash;
      link.classList.toggle('is-active', isActive);
      link.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    sectionElement.__activeHash = activeHash;
  }

  function getActiveItem(sectionElement, items) {
    var threshold = window.pageYOffset + getTotalOffset(sectionElement) + 8;
    var active = items[0] || null;

    items.forEach(function (item) {
      if (threshold >= item.top) {
        active = item;
      }
    });

    return active;
  }

  function getTargetScrollTop(sectionElement, item) {
    return Math.max(getAbsoluteTop(item.element) - getTotalOffset(sectionElement), 0);
  }

  function clearScrollCorrectionTimers(sectionElement) {
    toArray(sectionElement.__scrollCorrectionTimers || []).forEach(function (timer) {
      clearTimeout(timer);
    });
    sectionElement.__scrollCorrectionTimers = [];
  }

  function scheduleScrollCorrection(sectionElement, item) {
    clearScrollCorrectionTimers(sectionElement);

    [250, 700, 1300].forEach(function (delay) {
      var timer = window.setTimeout(function () {
        if (!sectionElement.__scrollLockHash || sectionElement.__scrollLockHash !== item.hash) return;

        var latestItems = sectionElement.__productAnchorNavItems || [item];
        refreshMeasurements(sectionElement, latestItems);

        var targetTop = getTargetScrollTop(sectionElement, item);
        if (Math.abs(window.pageYOffset - targetTop) > SCROLL_ALIGN_TOLERANCE) {
          window.scrollTo({
            top: targetTop,
            behavior: 'auto'
          });
        }
      }, delay);

      sectionElement.__scrollCorrectionTimers.push(timer);
    });
  }

  function scrollToItem(sectionElement, item, updateHash) {
    if (!item || !item.element) return;

    var latestItems = sectionElement.__productAnchorNavItems || [item];
    refreshMeasurements(sectionElement, latestItems);
    sectionElement.__scrollLockHash = item.hash;
    clearTimeout(sectionElement.__scrollLockTimer);
    clearScrollCorrectionTimers(sectionElement);

    var absoluteTop = getTargetScrollTop(sectionElement, item);

    window.scrollTo({
      top: absoluteTop,
      behavior: 'smooth'
    });

    scheduleScrollCorrection(sectionElement, item);

    sectionElement.__scrollLockTimer = window.setTimeout(function () {
      sectionElement.__scrollLockHash = '';
      clearScrollCorrectionTimers(sectionElement);
    }, 1200);
  }

  function buildLinks(sectionElement, items) {
    var listElement = sectionElement.querySelector(LIST_SELECTOR);
    if (!listElement) return;

    listElement.innerHTML = '';

    items.forEach(function (item) {
      var link = document.createElement('a');
      link.className = 'productAnchorNav__link';
      link.href = '#' + item.hash;
      link.textContent = item.title;
      link.setAttribute('data-anchor-hash', item.hash);
      link.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToItem(sectionElement, item, true);
        setActiveLink(sectionElement, item.hash);
      });
      listElement.appendChild(link);
    });
  }

  function applyHash(sectionElement, items) {
    var hash = window.location.hash ? window.location.hash.replace(/^#/, '') : '';
    if (!hash) return;

    var matchedItem = items.find(function (item) {
      return item.hash === hash || item.element.id === hash;
    });

    if (!matchedItem) return;

    window.setTimeout(function () {
      scrollToItem(sectionElement, matchedItem, false);
      setActiveLink(sectionElement, matchedItem.hash);
    }, 120);
  }

  function mount(sectionElement) {
    var items = collectTargets(sectionElement);

    if (!items.length) {
      sectionElement.hidden = true;
      return;
    }

    var itemsSignature = items
      .map(function (item) {
        return item.hash + ':' + item.title;
      })
      .join('|');

    if (sectionElement.__productAnchorNavSignature !== itemsSignature) {
      buildLinks(sectionElement, items);
      sectionElement.__productAnchorNavSignature = itemsSignature;
    }

    sectionElement.__productAnchorNavItems = items;
    refreshMeasurements(sectionElement, items);
    setStickyState(sectionElement);
    if (!sectionElement.__scrollLockHash) {
      setActiveLink(sectionElement, (getActiveItem(sectionElement, items) || items[0]).hash);
    }
    sectionElement.hidden = false;

    if (sectionElement.__productAnchorNavBound) return;
    sectionElement.__productAnchorNavBound = true;

    var scrollButton = sectionElement.querySelector('[data-product-anchor-nav-scroll]');
    if (scrollButton) {
      scrollButton.addEventListener('click', function () {
        var listElement = sectionElement.querySelector(LIST_SELECTOR);
        if (!listElement) return;

        var delta = listElement.clientWidth * 0.6 || 200;
        var targetLeft = listElement.scrollLeft + delta;

        if (typeof listElement.scrollTo === 'function') {
          listElement.scrollTo({
            left: targetLeft,
            behavior: 'smooth'
          });
        } else if (typeof listElement.scrollBy === 'function') {
          listElement.scrollBy({
            left: delta,
            behavior: 'smooth'
          });
        } else {
          listElement.scrollLeft = targetLeft;
        }
      });
    }

    var sync = rafThrottle(function () {
      var latestItems = sectionElement.__productAnchorNavItems || [];
      if (!latestItems.length) return;
      setStickyState(sectionElement);
      if (sectionElement.__scrollLockHash) {
        setActiveLink(sectionElement, sectionElement.__scrollLockHash);
        return;
      }
      var activeItem = getActiveItem(sectionElement, latestItems) || latestItems[0];
      if (activeItem) {
        setActiveLink(sectionElement, activeItem.hash);
      }
    });

    var refresh = debounce(function () {
      mount(sectionElement);
      sync();
    }, 60);

    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', refresh);
    window.addEventListener('load', function () {
      window.__productAnchorNavPageLoaded = true;
      refresh();
    });
    document.addEventListener('shopify:section:load', function () {
      refresh();
    });

    applyHash(sectionElement, items);
  }

  function init() {
    toArray(document.querySelectorAll(SECTION_SELECTOR)).forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (!window.__productAnchorNavPageLoaded) {
    window.addEventListener('load', function () {
      window.__productAnchorNavPageLoaded = true;
    });
  }
})();
